export default __webpack_public_path__ + "static/media/O-052.89a2891c.png";